import { InputV2, Text } from '@southfields-digital/mpxlive-components';

import { RugbyContestant } from 'src/types/matchControl/contestant';

import { ColorSwatch } from '../../components';
import styles from '../../MatchControl.module.scss';

type ScoreRowProps = {
  home: RugbyContestant;
  away: RugbyContestant;
  handleChangeColor: (
    contestant: RugbyContestant,
    color: 'primaryColor' | 'secondaryColor',
    value: string
  ) => void;
  handleChangeShortName: (contestant: RugbyContestant, name: string) => void;
};

// Score is calculated from scoring events so it is displayed read-only here
const ScoreRow = ({ home, away, handleChangeColor, handleChangeShortName }: ScoreRowProps) => (
  <div className="flex flex-col gap-6 w-full">
    <div className="flex gap-2 justify-around items-center">
      <div className="flex gap-2 flex-1 justify-start">
        <div className="flex">
          <ColorSwatch
            color={home.primaryColor}
            onChange={(color) => handleChangeColor(home, 'primaryColor', color)}
          />
          <ColorSwatch
            color={home.secondaryColor}
            onChange={(color) => handleChangeColor(home, 'secondaryColor', color)}
          />
        </div>

        <Text className="!text-4xl w-16 text-center" as="h1" color="light">
          {home.score.points}
        </Text>
      </div>

      <Text className="!text-4xl" as="h1" color="light">
        -
      </Text>

      <div className="flex gap-2 flex-1 justify-end">
        <Text className="!text-4xl w-16 text-center" as="h1" color="light">
          {away.score.points}
        </Text>

        <div className="flex">
          <ColorSwatch
            color={away.primaryColor}
            onChange={(color) => handleChangeColor(away, 'primaryColor', color)}
          />
          <ColorSwatch
            color={away.secondaryColor}
            onChange={(color) => handleChangeColor(away, 'secondaryColor', color)}
          />
        </div>
      </div>
    </div>

    <div className={styles.CurrentScoreWrapper}>
      <InputV2
        type="text"
        inputSize="lg"
        className="text-center text-lg w-12 min-w-0"
        value={home.shortName}
        onChange={(e) => handleChangeShortName(home, e.target.value)}
      />

      <InputV2
        type="text"
        inputSize="lg"
        className="text-center text-lg w-12 min-w-0"
        value={away.shortName}
        onChange={(e) => handleChangeShortName(away, e.target.value)}
      />
    </div>
  </div>
);

export default ScoreRow;
